/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Meta_SubtitleInputs */

const cs_settings_meta_subtitle = /** @type {(inputs: Settings_Meta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojte Facebook stránku (a Instagram Professional), ze které zveřejňujete vy. Firemní stránky zůstanou v Integracích.`)
};

const en_settings_meta_subtitle = /** @type {(inputs: Settings_Meta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect the Facebook Page (and Instagram Professional account) you post from as yourself. Company pages stay on Integrations.`)
};

/**
* | output |
* | --- |
* | "Connect the Facebook Page (and Instagram Professional account) you post from as yourself. Company pages stay on Integrations." |
*
* @param {Settings_Meta_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_meta_subtitle = /** @type {((inputs?: Settings_Meta_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Meta_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_meta_subtitle(inputs)
	return cs_settings_meta_subtitle(inputs)
});